import { render, staticRenderFns } from "./TrustEditorDialog.vue?vue&type=template&id=abfb91b0"
import script from "./TrustEditorDialog.vue?vue&type=script&lang=js"
export * from "./TrustEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./TrustEditorDialog.vue?vue&type=style&index=0&id=abfb91b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports